<div class="grid">
  <div class="centred">
    <img src="assets/img/404.svg" class="image">
    <h2>{{text}}</h2>
  </div>
</div>
